var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.41797 17.0697V3.73633H5.08464V17.0697H3.41797ZM9.2513 17.0697V13.7363H10.918V17.0697H9.2513ZM15.0846 17.0697V3.73633H16.7513V17.0697H15.0846ZM9.2513 12.0697V8.73633H10.918V12.0697H9.2513ZM9.2513 7.06966V3.73633H10.918V7.06966H9.2513Z",
    fill: "white"
  }))));
};
export { SvgLine as ReactComponent };
export default __webpack_public_path__ + "assets/8666b3f7.svg";